angular.module('impactx.rfx').controller('RFQCInfoCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    'DownloadService',
    'ShareLinkService',
    'ToolbarService',
    'SearchService',
    'AppConfiguration',
    RFQCInfoCtrl
]);

function RFQCInfoCtrl($scope, $routeParams, dataGen, DownloadService, ShareLinkService, ToolbarService, SearchService, AppConfiguration) {
    var self = this;
    self.informationIsOpen = true;
    self.panelsInitialized = false;
    self.showSupplierSearch = AppConfiguration.get('showSupplierSearch');
    self.expandCatalogSupplierDefault = SearchService.userSearchConfig('expandCatalogSupplierDefault');
    self.displayAllResultsAsList = AppConfiguration.get('displayAllResultsAsList');

    dataGen.getData($scope, {id: $routeParams.id}, "/rfx/rfqc/info").then(function () {
        $scope.setButtons();
        self.panelsInitialized = true;
    });

    self.downloadAttachment = function (media) {
        DownloadService.openDownloadPost('/rfx/download/media', {paramName: "id", paramValue: media.id});
    };

    self.copyLinkToClipboard = function () {
        ShareLinkService.shareLinkByClipboard();
    };

    self.shareLink = function () {
        ShareLinkService.shareLinkByMessage();
    };

    $scope.setButtons = function () {
        $scope.buttonDefinition = [
            {
                label: $scope.trns.link, action: self.copyLinkToClipboard, type: 'dialogaction'
            },
            {
                label: $scope.trns.shareLink, action: self.shareLink, type: 'dialogaction', process: 'Message'
            }
        ];

        ToolbarService.setButtons($scope.buttonDefinition);
    };

    self.toggleInformation = function () {
        self.informationIsOpen = !self.informationIsOpen
    };

    $scope.$on('$destroy', function () {
        SearchService.setUserSearchConfigParameter('expandCatalogSupplierDefault', self.expandCatalogSupplierDefault);
        ToolbarService.hideSearchFilterToggle();
    });
}